export const DATAFORMPROMOTER = 'DATAFORMPROMOTER';
export const DATASCENARIOS = 'DATASCENARIOS';
export const DATANEWPROJECT = 'DATANEWPROJECT';
export const LOADING = 'LOADING';
export const REDIRECT = 'REDIRECT';
export const DATALISTMYPROYECTS = 'DATALISTMYPROYECTS';
export const OPERATIONDATAHADMIN = 'OPERATIONDATAHADMIN';
export const OPERATIONDATACLIENT = 'OPERATIONDATACLIENT';
